<template>
    <span class="text-skeleton" aria-hidden="true">
        <span v-for="line in lines" :key="line" class="text-skeleton__line"
            :class="{ 'text-skeleton__line--last': line === lines }"></span>
    </span>
</template>

<script>
    export default {
        name: 'TextSkeleton',
        props: {
            lines: {
                type: Number,
                default: 2,
                validator: (value) => value > 0
            }
        }
    }
</script>

<style scoped>
    .text-skeleton {
        display: flex;
        width: 100%;
        min-width: 120px;
        flex-direction: column;
        gap: 5px;
        padding: 2px 0;
    }

    .text-skeleton__line {
        display: block;
        width: 100%;
        height: 10px;
        border-radius: 2px;
        background: linear-gradient(90deg,
                rgba(127, 142, 157, 0.2) 20%,
                rgba(127, 142, 157, 0.42) 50%,
                rgba(127, 142, 157, 0.2) 80%);
        background-size: 220% 100%;
        animation: text-skeleton-shimmer 1.35s ease-in-out infinite;
    }

    .text-skeleton__line--last {
        width: 72%;
    }

    @keyframes text-skeleton-shimmer {
        from {
            background-position: 100% 0;
        }

        to {
            background-position: -100% 0;
        }
    }

    @media (prefers-reduced-motion: reduce) {
        .text-skeleton__line {
            animation: none;
        }
    }
</style>
